export default __webpack_public_path__ + "static/media/social-meida-img.5730dcb0.png";